module.exports = __webpack_public_path__ + "resources/img/sp_webbric.ba92c743d0bf9f4d808056c121b4a404.png";